import { render, staticRenderFns } from "./AccessRight.vue?vue&type=template&id=4b26ed66"
import script from "./AccessRight.vue?vue&type=script&lang=js"
export * from "./AccessRight.vue?vue&type=script&lang=js"
import style0 from "./AccessRight.vue?vue&type=style&index=0&id=4b26ed66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports